import CarWithoutSliderContainer from "../../../components/car/other/CarWithoutSlider";

const CarWithoutSlider = () => {
  return <CarWithoutSliderContainer />;
};

export default CarWithoutSlider;
